export const currencyFormatter = () =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

export const currencyBrlMask = (amount: string): string => {
  let onlyNumbers = Number(amount.replaceAll(/\D/g, '')) / 100;

  if (Number.isNaN(onlyNumbers)) {
    onlyNumbers = 0;
  }

  return currencyFormatter().format(onlyNumbers);
};

export const formatCurrency = (value: number): string =>
  currencyFormatter().format(value);

export function parseCurrencyBRLToNumber(value?: string | null): number {
  if (!value) {
    return 0;
  }

  const normalized = value
    .replaceAll(/\s/g, '')
    .replace('R$', '')
    .replaceAll('.', '')
    .replace(',', '.');

  const number = Number(normalized);

  return Number.isNaN(number) ? 0 : number;
}

export const centsToBrl = (cents: number): string =>
  currencyFormatter().format(cents / 100);
